// projects — the author's projects as the lists show them, projected from
// the Library, pure.
//
// A project (Studio v1 D1) is a workspace for one course; its canvas holds
// materials and sources by reference. A list shows its name and what lies
// on its canvas: how many modules (materials whose container kind is
// "module") and how many cards in all.

export { projectsOf };

import type { Library } from "../../app/ports.js";

type Project = {
    readonly id: string;
    readonly title: string;
    readonly archived: boolean;
    // How many of the canvas's items are modules.
    readonly modules: number;
    // How many items lie on the canvas.
    readonly cards: number;
};

// In the Library's order; null (not loaded yet) is none.
const projectsOf = (library: Library | null): readonly Project[] => {
    if (library === null) return [];
    const modules = new Set(
        library.materials
            .filter((m) => m.container?.kind === "module")
            .map((m) => m.id),
    );
    return (library.projects ?? []).map((p) => ({
        id: p.id,
        title: p.title,
        archived: p.lifecycle === "archived",
        modules: p.canvas.filter((item) => modules.has(item.target)).length,
        cards: p.canvas.length,
    }));
};
